import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { ButtonProps, Grid, Button as MuiButton } from "@material-ui/core";
import { useActions } from "../../actions";
import * as Actions from "../../actions/account";
import * as ClientActions from "../../actions/client";
import { ErrorCommon, NumberTextField, SelectField, TextField, TextFieldCommon } from "../formikFormInputs";
import { Formik, FormikHelpers } from "formik";
import { Button, Label } from "../formInputs";
import { Button as FormikButton } from "../../components/formInputs";
import NumberFormat from "react-number-format";
import {unmaskCurrency} from "../../utils/commonUtils";
import { ActionItems as CurrentActionsItems, PaymentProcess } from "../../constants";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import * as PaymentActions from "../../actions/payment";
import * as TrancheActions from "../../actions/tranche";
import { Dialog as GenericDialog, GenericDialogProps } from "../dialog";
import { usePolicyContext } from "../clientServicing/Payments/PolicyContext";
import PaymentDocument from "../clientServicing/Payments/PaymentDocument";
import RejectPaymentModel from "../clientServicing/Payments/RejectPaymentModel";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RequestDocuments from "../clientServicing/Payments/RequestDocuments";

const styles: any = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: "10px",
        top: "16px",
        color: theme.palette.grey[500],
    },
});

const DialogTitle: any = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="body1" component="strong">{children}</Typography>
                {onClose ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                ) : null}
            </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);


export default function PaymentReceivedPopUp(props: {
    open: boolean,
    setPaymentReceivedPopUp: Function,
    enrollmentId: string,
    agentId: number,
    client: any,
    refreshList: Function,
    setFilterType?: Function,
    role?: number,
    clientPolicy?: any
}) {
    const {
        open,
        setPaymentReceivedPopUp,
        enrollmentId,
        agentId,
        client,
        refreshList,
        setFilterType,
        role,
        clientPolicy
    } = props;
    const [tranche, setTranche] = React.useState<any>([]);
    const [nextPaymentDetails, setNextPaymentDetails] = React.useState<any>([]);
    const auth: any = useSelector((state: RootState) => state.auth);
    const accountActions = useActions(Actions);
    const { processPayment, rejectPayment } = useActions(PaymentActions);
    const clientActions = useActions(ClientActions);
    const trancheActions = useActions(TrancheActions);
    const [requestForDocs, setRequestForDoc] = React.useState(false);
    const listTrancheCount:number = 25;
    const [rejectModel, setRejectModel] = React.useState(false);
    const commonButtonProps: ButtonProps = {color: "primary", size: 'small', variant: 'contained'};
    const { policy }: any = usePolicyContext();
    const isEPayPayment = !!(policy && policy.clientPayments && policy.clientPayments.find((x) => x.type === "ePay"));
    const mergeMarkPaymentReceivedAndMPProcessed = role != 12
    const handleClose = () => {
        setPaymentReceivedPopUp(false);
        refreshList();
    };
    console.log(clientPolicy," ==== clientPolicy")
    const showCheckWireFields = (values) =>{
        return ['personal_check', 'wire_transfer'].includes(values.fundingType) && mergeMarkPaymentReceivedAndMPProcessed;
    }

    function SupportingDocumentsContent() {
        if (clientPolicy && clientPolicy.supportingDocuments) {
            return (
                    <>
                        <Typography>The document request is already sent to client.</Typography>
                    </>
            );
        } else {
            return (
                    <>
                        <Typography>What would you like to tell the client? If there is a specific document needed,
                            state that here.</Typography>
                        <RequestDocuments onSubmit={handleHide} clientPolicyId={clientPolicy && clientPolicy.id} />
                        <MuiButton color="secondary" className="floatRight textBlack" onClick={handleHide}>
                            Cancel
                        </MuiButton>
                    </>
            );
        }
    }
    React.useEffect(() => {
        if(auth && auth.user && (auth.user.role <= 2 || auth.user.role === 12) ) {
            getTranches();
        }
    }, [])

    React.useEffect(() => {
        if(clientPolicy && clientPolicy.paymentFrequency === "annual") {
            setNextPaymentDetails(policy && policy.paymentTimetableAnnual)
        } else {
            setNextPaymentDetails(policy && policy.paymentTimetableMonthly)
        }
    }, [clientPolicy])

    const getTranches = async () => {
        let payload:any = [];
        const response: any = await trancheActions.listUpcomingTranche(listTrancheCount);
        response.map((tranche:any)=>{
            payload.push({
                id: tranche.id,
                value: tranche.id,
                name: tranche.trancheNumber
            });
        });
        setTranche(payload);
    }

    const initialValues = {
        fundingType: clientPolicy && clientPolicy.payment_method || (isEPayPayment ? 'ePay' : ""),
        receivedAmount: clientPolicy && clientPolicy.issuedContribution,
        trancheNo: clientPolicy && clientPolicy.trancheNo,
        paymentDocumentPath: "",
        notes: ""
    };
    const validate = ((value: any) => {
        const errors: { fundingType?: string, receivedAmount?: string, trancheNo?:string, notes?: string, paymentDocumentPath?: string } = {};
        if (!value.fundingType) {
            errors.fundingType = "Required";
        }
        if (!value.receivedAmount || value.receivedAmount < 1) {
            errors.receivedAmount = "Required";
        }
        if (!value.trancheNo) {
            errors.trancheNo = "Required";
        }
        if(showCheckWireFields(value)) {
            if (!value.notes) {
                errors.notes = "Required";
            }
            if (!value.paymentDocumentPath) {
                errors.paymentDocumentPath = "Required";
            }
        }

        return errors;
    });
    let fundingType: any[] =[];
    if(!isEPayPayment){
    fundingType = [
            {
                id: 1,
                key: "personal_check",
                value: "personal_check",
                name: "Personal Check",
            },
            {
                id: 2,
                key: "wire_transfer",
                value: "wire_transfer",
                name: "Wire Transfer",
            },
        ];
    }
    fundingType.push({
        id: 3,
        key: "ePay",
        value: "ePay",
        name: "ePay",
    })
    const policyRow = policy && policy.clientPayments && policy.clientPayments.filter(payment => !!(payment.amount)).length > 0;
    const show = (values) =>{
        return true
    }
    const fieldObj = [
        {
            name: "fundingType",
            component: SelectField,
            className: "SelectFieldWidth",
            label: <Label label={"Funding Type"} required={true} />,
            variant: "outlined",
            options: fundingType,
            show: show,
            isRequired: true
        },
        {
            id:"receivedAmount",
            name: "receivedAmount",
            label: <Label label={"Enter Received Amount"} required={true}/>,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            show: show,
            disabled: false,
        },
        {
            id: "trancheNo",
            name: "trancheNo",
            component: SelectField,
            className: "SelectFieldWidth",
            label: <Label label={"Closed Tranche No"} required={true} />,
            variant: "outlined",
            options: tranche,
            isRequired: true,
            show: show,
            disabled:(values) => {
                return ((values["fundingType"] === "ePay") && !!policyRow) || isEPayPayment
            }
        },
        {
            id: "notes",
            name: "notes",
            label: <Label label={"Notes"} required={true} />,
            isRequired: false,
            placeholder: "Add Notes ...",
            component: TextField,
            className: "fullWidthcustomFields",
            multiline: true,
            show: showCheckWireFields,
            size: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 6,
            },
        },
    ];
    const closeRejectModal = () => {
        setRejectModel(false);
    }
    const onRejectPayment = async (values: any, formikProps: FormikHelpers<any> ) =>{
        const result = await rejectPayment({ clientPolicyId: clientPolicy.id, rejectionMessage: values.reason });
        // if new record created send email for rejection
        if(result && result.success){
            processPayment({type: PaymentProcess.checkWire, userId: client.userId, clientPolicyId: clientPolicy.id, reason: values.reason })
        }
        closeRejectModal();
    }

    const handleHide = async () => {
        setRequestForDoc(false);
        refreshList()
    };
    const confirmDialog: GenericDialogProps = {
        "aria-describedby": "delete-tranche-notes-pop-up",
        'aria-labelledby': 'Delete Note',
        actions: (
                <>
                    <MuiButton {...commonButtonProps} color="secondary" onClick={closeRejectModal}>
                        Close
                    </MuiButton>
                    <MuiButton {...commonButtonProps} type={"submit"} form="reject-form"  className="bgRed">
                        Confirm
                    </MuiButton>
                </>
        ),
        content: (

                <RejectPaymentModel onSubmit={onRejectPayment} />
        ),
        fullWidth: true,
        maxWidth: "sm",
        onClose: closeRejectModal,
        open: rejectModel,
        title: 'Reject Payment',
    };

    const documentsDialogProps: GenericDialogProps = {
        "aria-labelledby": "Edit-Calculation-Inputs-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (<SupportingDocumentsContent />),
        title: "Request Supporting Documents",
        dividers: true,
        onClose: handleHide,
        open: requestForDocs,
    };

    const dialogProps: GenericDialogProps = {
        'aria-labelledby': "Enter-Payment-Received-Amount-dialog-title",
        fullWidth: true,
        maxWidth: "sm",
        content: (<>
                <Typography variant="body1" className="f18" align="center">
                    Enter the initial contribution amount that has been received for reporting purposes.
                </Typography>
            <GenericDialog {...confirmDialog} />
    <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validate={values => validate(values)}
            validateOnChange={true}
            onSubmit={async (values, { setSubmitting }) => {
                let selectedTranche:any = tranche.find((val:any) => val.id === values.trancheNo);
                let trancheClosed:number = Number(selectedTranche && selectedTranche.name);
                let trancheNo:number = Number(values && values.trancheNo);
                let receivedAmount:number = Number(unmaskCurrency(values.receivedAmount.toString()));
                const res =  await accountActions.markPaymentReceived({
                    receivedAmount: receivedAmount,
                    agentId,
                    enrollmentId,
                    trancheClosed,
                    trancheNo,
                    fundingType: values.fundingType,
                    notes: values.notes,
                    policyNumber: policy && policy.policyNumber,
                    files: values.paymentDocumentPath ? [values.paymentDocumentPath] : []
                });

                if (res !== false){
                    await processPayment({
                        type: PaymentProcess.paymentReceived,
                        userId: client.userId,
                        clientPolicyId: clientPolicy.id,
                        nextPaymentDetails: nextPaymentDetails
                    })
                }
                await clientActions.getClient(client.id, clientPolicy.id);
                if(setFilterType && role !== 4) {
                    setFilterType(CurrentActionsItems.MARK_PAYMENT_PROCESSED.actionType);
                    setPaymentReceivedPopUp(false);
                } else {
                    handleClose();
                }
            }}
    >
        {({
              values,
              errors,
              touched,
              handleChange,
              setFieldValue,
              handleBlur,
              handleSubmit,
              isSubmitting,
              dirty,
          }) => (<form onSubmit={handleSubmit}>
            <Grid container spacing={2} className="mt15 mb20">
                {
                        requestForDocs &&
                        <GenericDialog {...documentsDialogProps} />
                }
                {fieldObj.map((field:any, index) => {
                    return (
                            field.show(values) && <Grid item xs={(field.size && field.size.xs) || 6}
                                  md={(field.size && field.size.md) || 6}
                                  key={index} className="mb5">
                                <TextFieldCommon
                                        className="dollerIcon"
                                        {...field}
                                        disabled={(typeof field.disabled == "function") ? field.disabled(values) : field.disabled  }
                                        values={values}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                />
                                <ErrorCommon errors={errors} name={field.name}
                                             touched={touched}/>
                                {field.name === 'receivedAmount' &&
                                        <Typography variant='body1' align="left" className="f18">
                                            Amount due:&nbsp;
                                            <NumberFormat
                                                    value={(clientPolicy && clientPolicy.issuedContribution) || 0}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={"$"}/>
                                        </Typography>
                                }
                            </Grid>
                    );
                })
                }
            </Grid>
            {showCheckWireFields(values) && <Grid item xs={12} md={12} className="mb5">
                <PaymentDocument fieldName={"paymentDocumentPath"} />
                <ErrorCommon errors={errors} name={"paymentDocumentPath"}
                             touched={{"paymentDocumentPath": true}}/>
            </Grid>}
            {mergeMarkPaymentReceivedAndMPProcessed && <> <Grid item xs={12} md={5} className="textCenter mb20">
                <MuiButton color="primary" className="mt10" onClick={() => {
                    setRequestForDoc(true);
                }}>
                    <AddCircleIcon className="floatLeft mr15 " /> Request Supporting Documents
                </MuiButton>
            </Grid>
            <Button
                    label={"Reject Payment"}
                    type="button"
                    variant="contained"
                    onClick={() => {
                        setRejectModel(true);
                        // setOpenPopup(false);
                    }}
                    color="primary"
                    className="btnContainedRed floatLeft "
            /></>}
            <FormikButton
                    fullWidth={false}
                    type="submit"
                    label={mergeMarkPaymentReceivedAndMPProcessed ? "Accept" : "Mark Payment Received"}
                    variant="contained"
                    className="floatRight"
                    color="primary"
                    disabled={isSubmitting}
                    loading={isSubmitting}
            />
        </form>)}

    </Formik>
        </>),
        dividers: true,
        onClose: handleClose,
        open: open,
        title: 'Enter Payment Received Amount'
    };

    return (
            <>
                <GenericDialog {...dialogProps} />
            </>
    );
}
